module.exports = __webpack_public_path__ + "img/image-16.bc7854d9.svg";